import type { BrowserActionDefinition } from '@segment/browser-destination-runtime/types'
import type { Settings } from '../generated-types'
import type { Payload } from './generated-types'
import type { FS } from '../types'
import { segmentEventSource } from '..'

const action: BrowserActionDefinition<Settings, FS, Payload> = {
  title: 'Track Event V2',
  description: 'Track events',
  platform: 'web',
  defaultSubscription: 'type = "track"',
  fields: {
    name: {
      description: 'The name of the event.',
      label: 'Name',
      required: true,
      type: 'string',
      default: {
        '@path': '$.event'
      }
    },
    properties: {
      description: 'A JSON object containing additional information about the event that will be indexed by FullStory.',
      label: 'Properties',
      required: false,
      type: 'object',
      default: {
        '@path': '$.properties'
      }
    }
  },
  perform: (FS, event) => {
    FS(
      'trackEvent',
      {
        name: event.payload.name,
        properties: event.payload.properties ?? {}
      },
      segmentEventSource
    )
  }
}

export default action
